import { render, staticRenderFns } from "./ghPdf.vue?vue&type=template&id=21de6fa0&scoped=true&"
import script from "./ghPdf.vue?vue&type=script&lang=js&"
export * from "./ghPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21de6fa0",
  null
  
)

export default component.exports